/************ PRODUCT INFO AJAX ***********/

var g_has_recoloured = '';
var g_new_recoloured = '';

function refreshProductInfo(optionId, clear, selectionHighlightsActive) {

  if (clear) {
    INFO_PAGE.refreshSettings.size_id = 0;
    INFO_PAGE.refreshSettings.size_title = 'size';

    INFO_PAGE.refreshSettings.secondary_size_id = 0;
    INFO_PAGE.refreshSettings.secondary_size = 'secondary_size';

    INFO_PAGE.refreshSettings.colour_id = 0;
    INFO_PAGE.refreshSettings.colour = 'colour';
  } else if (optionId != 'bespoke_fit_classic' && optionId != 'bespoke_fit_slim') {
    if (INFO_PAGE.product_options[ optionId ][ 'type' ] == 'size') {
      INFO_PAGE.refreshSettings.size_id = INFO_PAGE.product_options[ optionId ][ 'id' ];
      INFO_PAGE.refreshSettings.size_title = INFO_PAGE.product_options[ optionId ][ 'url_title' ];
    }
    if (INFO_PAGE.product_options[ optionId ][ 'type' ] == 'secondary_size') {
      INFO_PAGE.refreshSettings.secondary_size_id = INFO_PAGE.product_options[ optionId ][ 'id' ];
      INFO_PAGE.refreshSettings.secondary_size = INFO_PAGE.product_options[ optionId ][ 'url_title' ];
    }
    if (INFO_PAGE.product_options[ optionId ][ 'type' ] == 'colour') {
      INFO_PAGE.refreshSettings.colour_id = INFO_PAGE.product_options[ optionId ][ 'id' ];
      INFO_PAGE.refreshSettings.colour = INFO_PAGE.product_options[ optionId ][ 'title' ];
    }
  }

  var data = '';

  data += 'category_id';
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.category_id);
  data += "&";

  data += 'category';
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.category);
  data += "&";

  data += 'style_id';
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.style_id);
  data += "&";

  data += 'style';
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.style_title);
  data += "&";

  data += 'brand_id';
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.brand_id);
  data += "&";

  data += 'brand';
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.brand);
  data += "&";

  data += 'size_id';
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.size_id);
  data += "&";

  data += 'size';
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.size_title);
  data += "&";

  data += 'secondary_size_id';
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.secondary_size_id);
  data += "&";

  data += 'secondary_size';
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.secondary_size);
  data += "&";

  data += 'colour_id';
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.colour_id);
  data += "&";

  data += 'colour';
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.colour);
  data += "&";

  data += 'fabric_id';
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.fabric_id);
  data += "&";

  data += 'fabric';
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.fabric);
  data += "&";

  data += 'occasion_id';
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.occasion_id);
  data += "&";

  data += 'occasion';
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.occasion);
  data += "&";

  data += 'sale';
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.sale);
  data += "&";

  data += 'product_id';
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.product_id);
  data += "&";

  data += 'so_id';
  data += "=";
  data += escape(INFO_PAGE.refreshSettings.so_id);
  data += "&";

  data += 'bespoke_fit';
  data += "=";
  var bespoke_fit = 'classic';
  if (optionId == 'bespoke_fit_slim') {
    bespoke_fit = 'slim';
  }
  if ($('input[name=bespoke_fit]:checked').length) {
    bespoke_fit = $('input[name=bespoke_fit]:checked').val();
  }
  data += escape(bespoke_fit);
  data += "&";

  var rand = Math.random(9999);
  var pars = data + 'rand=' + rand;

  g_has_recoloured = '';
  if (optionId != '0') {
    g_has_recoloured = 'n';

    if (optionId != 'bespoke_fit_classic' && optionId != 'bespoke_fit_slim') {
      if (INFO_PAGE.product_options[ optionId ][ 'type' ] == 'colour') {
        if (INFO_PAGE.product_options[ optionId ][ 'has_recoloured' ] == 'y') {
          g_has_recoloured = 'y';
          g_new_recoloured = INFO_PAGE.refreshSettings.product_id + '-' + INFO_PAGE.product_options[ optionId ][ 'id' ];
        }
      }
    }
  }


  $.get('/lib/ajax_product_info_json.php', pars, function (newData) {

    var info_content = newData.info;
    var size_charts = newData.size_charts;
    var price_box = newData.price_box;

    var selections_panel = $('.selections-wrapper');
    selections_panel.html(info_content);

    var size_charts_div = $('.size-chart-container');
    size_charts_div.html(size_charts);

    $('.price_box-xs').html(price_box);
    $('.price_box-sm').html(price_box);
    $('.price_box-btn').html(price_box);

    //Measurement Sizechart and diagrams
    $('.mv').removeClass('active_size');
    $('.mv').removeClass('active_secondary_size');

    $('.mv').each(function () {
      if ($(this).hasClass('s_' + INFO_PAGE.refreshSettings.size_id)) $(this).addClass('active_size');
      if ($(this).hasClass('ss_' + INFO_PAGE.refreshSettings.secondary_size_id) && INFO_PAGE.refreshSettings.secondary_size_id != '0') $(this).addClass('active_secondary_size');
    });

    //if a main size is set update any diagrams main size values
    if (INFO_PAGE.refreshSettings.size_id != '0') {
      var main_inch = $('.ms_s_' + INFO_PAGE.refreshSettings.size_id + ' > .inch').html();
      var main_cm = $('.ms_s_' + INFO_PAGE.refreshSettings.size_id + ' > .cm').html() + 'cm';

      $('.diagram_measurement.main_size > .inch').html(main_inch);
      $('.diagram_measurement.main_size > .cm').html(main_cm);
    }

    //if a secondary size is set update any diagrams secondary size values
    if (INFO_PAGE.refreshSettings.secondary_size_id != '0') {
      var ss_inch = $('.secondary_size.ss_' + INFO_PAGE.refreshSettings.secondary_size_id + ' > .inch').html();
      var ss_cm = $('.secondary_size.ss_' + INFO_PAGE.refreshSettings.secondary_size_id + ' > .cm').html() + 'cm';

      $('.diagram_measurement.secondary_size > .inch').html(ss_inch);
      $('.diagram_measurement.secondary_size > .cm').html(ss_cm);
    }

    if (selectionHighlightsActive) {
      ITEM_INFO.messageOn();
    }

    var measurement_type_id = 0;
    var mt_inch = '';
    var mt_cm = '';
    //check if there are any secondary sizes for this product
    if ($('.secondary_size').length) {
      //has secondary sizes
      $('.active_size.active_secondary_size').each(function () {

        var classList = $(this).attr('class').split(/\s+/);
        for (i = 0; i < classList.length; i++) {
          if (classList[ i ].length > 0) {
            if (classList[ i ].match(/mt_id_(\d*)/)) {
              measurement_type_id = RegExp.$1;
              mt_inch = $(this).find('.inch').html();
              mt_cm = $(this).find('.cm').html() + 'cm';
              $('.diagram_measurement.mt_id_' + measurement_type_id + ' > .inch').html(mt_inch);
              $('.diagram_measurement.mt_id_' + measurement_type_id + ' > .cm').html(mt_cm);
            }
          }
        }


      });
    } else {
      //no secondary sizes
      $('.active_size').each(function () {

        var classList = $(this).attr('class').split(/\s+/);
        for (i = 0; i < classList.length; i++) {
          if (classList[ i ].length > 0) {
            if (classList[ i ].match(/mt_id_(\d*)/)) {
              measurement_type_id = RegExp.$1;
              mt_inch = $(this).find('.inch').html();
              mt_cm = $(this).find('.cm').html() + 'cm';
              $('.diagram_measurement.mt_id_' + measurement_type_id + ' > .inch').html(mt_inch);
              $('.diagram_measurement.mt_id_' + measurement_type_id + ' > .cm').html(mt_cm);
            }
          }
        }


      });
    }

    //restore add to bag tracking
    // $("#product_info_form #buy").unbind('click');
    $("#product_info_form #buy").on('click', function (e) {
      e.stopPropagation();
      var qtyInput = $('#qty_heading + input');


      try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "add_to_cart",
            currency: "GBP",
            value: newData.plain_price,
            ecommerce: {
                items: [ {
                  item_id: INFO_PAGE.refreshSettings.product_id,
                  item_name: INFO_PAGE.product_title,
                  item_category: INFO_PAGE.refreshSettings.category,
                  item_variant: newData.plain_size + ' ' + newData.plain_secondary_size + ' ' + newData.colour,
                  item_brand: INFO_PAGE.product_brand,
                  currency: "GBP",
                  price: newData.plain_price,
                  quantity: qtyInput.val(),
                  index: 0,
                  dimension1: newData.plain_size,
                  dimension2: newData.plain_secondary_size,
                  dimension3: newData.colour,
                } ]
            }
          });
      } catch (error) {
        // console.log(error);
      }
    });

    $('#photo-carousel').carousel({ interval: false });
    $(".carousel").swiperight(function () {
      $(".carousel").carousel('prev');
    });
    $(".carousel").swipeleft(function () {
      $(".carousel").carousel('next');
    });


    //restore addThis
    // addthis.toolbox('.addthis_toolbox');

  }, 'json');


  //return false;
}
